import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a8717b9c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "bg-light mb-2 mt-3 py-1 px-2 shadow-sm rounded" };
const _hoisted_2 = { class: "menus-container" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "text-blue clique-para-detalhar" }, " Clique nos campos para detalhar ", -1));
const _hoisted_4 = { class: "btn btn-quadrado pointer valor-descricao-container shadow-none" };
const _hoisted_5 = { class: "valor" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("div", { class: "descricao" }, "Doações Recebidas")
], -1));
const _hoisted_7 = { class: "btn btn-quadrado bg-taxas pointer text-black valor-descricao-container shadow-none" };
const _hoisted_8 = { class: "valor" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("div", { class: "descricao" }, "Taxas")
], -1));
const _hoisted_10 = { class: "btn btn-quadrado bg-saque-realizado border-none text-black valor-descricao-container shadow-none" };
const _hoisted_11 = { class: "valor" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("div", { class: "descricao" }, "Saques Realizados")
], -1));
const _hoisted_13 = { class: "btn btn-quadrado bg-saldo-receber text-black valor-descricao-container shadow-none" };
const _hoisted_14 = { class: "valor" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("div", { class: "descricao" }, "Saldo")
], -1));
const _hoisted_16 = {
    key: 0,
    class: "text-center"
};
const _hoisted_17 = { id: "lista-depositos" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MobileLikeNavHeader = _resolveComponent("MobileLikeNavHeader");
    const _component_AlertaErroContaCadastrada = _resolveComponent("AlertaErroContaCadastrada");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_MobileLikeNavHeader, {
            title: "Financeiro",
            height: "100px",
            "go-back-url": "/restrito#/"
        }),
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.irParaDoacoesRecebidas()))
            }, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.resumoFinanceiro?.total_bruto), 1)
                    ]),
                    _hoisted_6
                ])
            ]),
            _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.showModalTaxas()))
            }, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.resumoFinanceiro?.total_taxas), 1)
                    ]),
                    _hoisted_9
                ])
            ]),
            _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.resumoFinanceiro?.saques_realizados), 1)
                    ]),
                    _hoisted_12
                ])
            ]),
            _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.resumoFinanceiro?.saldo_receber), 1)
                    ]),
                    _hoisted_15
                ])
            ]),
            _createVNode(_component_AlertaErroContaCadastrada)
        ]),
        (_ctx.listaDepositos.length > 0)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_16, " Lista de Saques "))
            : _createCommentVNode("", true),
        _createElementVNode("ul", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listaDepositos, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                    style: _normalizeStyle({ backgroundColor: item.backgroundColor })
                }, _toDisplayString(_ctx.converteData(item.start)) + " - " + _toDisplayString(item.title), 5));
            }), 256))
        ])
    ]));
}
